import { LOCALE_ID, NgModule } from '@angular/core';
import { CommonModule, CurrencyPipe, DatePipe } from '@angular/common';
import { VendaEntregaComponent } from './venda-entrega/venda-entrega.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_DATE_LOCALE, DateAdapter } from '@angular/material';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { MentionModule } from 'angular-mentions';
import { TextMaskModule } from 'angular2-text-mask';
import { NgBrazil } from 'ng-brazil';
import { NgDragDropModule } from 'ng-drag-drop';
import { CurrencyMaskModule } from 'ng2-currency-mask';
import { FileUploadModule } from 'ng2-file-upload';
import { ClipboardModule } from 'ngx-clipboard';
import { ColorPickerModule } from 'ngx-color-picker';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { LightboxModule } from 'ngx-lightbox';
import { IConfig, NgxMaskModule } from 'ngx-mask';
import {
  PerfectScrollbarConfigInterface,
  PerfectScrollbarModule,
  PERFECT_SCROLLBAR_CONFIG,
} from 'ngx-perfect-scrollbar';
import { NgxSpinnerModule } from 'ngx-spinner';
import { NgxSummernoteModule } from 'ngx-summernote';
import { ComumModule } from '../comum/comum.module';
import { CustomDateAdapter } from '../data-adapter/custom-data-adapter';
import { DirectivesModule } from '../directives/directives.module';
import { MaterialModule } from '../material.module';
import { MdModule } from '../md/md.module';
import { PipesModule } from '../pipes/pipes.module';

export let options: Partial<IConfig> | (() => Partial<IConfig>) = {};

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
};

@NgModule({
  declarations: [VendaEntregaComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MdModule,
    MaterialModule,
    TextMaskModule,
    NgBrazil,
    NgSelectModule,
    NgxMaskModule.forRoot(options),
    CurrencyMaskModule,
    NgxSpinnerModule,
    FileUploadModule,
    PerfectScrollbarModule,
    NgxChartsModule,
    PipesModule,
    NgDragDropModule.forRoot(),
    NgxSummernoteModule,
    DirectivesModule,
    NgxDropzoneModule,
    ClipboardModule,
    LightboxModule,
    ColorPickerModule,
    ComumModule,
    MentionModule,
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'pt-BR' },
    { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' },

    { provide: DateAdapter, useClass: CustomDateAdapter },
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG,
    },
    CurrencyPipe,
    DatePipe,
  ],
  exports: [VendaEntregaComponent],
})
export class VendaEntregaModule {}
